module.exports = __webpack_public_path__ + "static/GodWitchcraftA-500b26c3bd8e96325df00697784ede6a.gif";